var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},_vm._l((_vm.reviews),function(review,idx){return _c('ReviewListItem',{key:idx,staticClass:"col d-flex",attrs:{"review":review}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }